/* eslint-disable @typescript-eslint/no-explicit-any */

type GtagCommand = 'config' | 'get' | 'set' | 'event' | 'consent'

/**
 * View methods for GA (Google Analytics)
 * @param command The command.
 * @param args Parameters that vary according to the command passed.
 */
function gtag(command: GtagCommand, ...args: any[]) {
  return (window as any).gtag(command, ...args)
}

export default gtag
